import React from 'react';
import { element, func } from 'prop-types';
import { Box, IconButton, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';

import { Form, StyledDrawer } from './styles';
import { staticText } from '../../../../../../../../../localization/Application/VehicleManagement/filtersBar';
import { allSelectFilters } from '../../../../../../../../../localization/Application/Logs/webhooksFiltersBar';

const [statusCodeFilter, eventTypeFilter] = allSelectFilters;

const AllFiltersDrawer = ({
  closeDrawer,
  createDateFilter,
  submitButton,
  resetButton,
  handleSubmit,
  createSelectFilters,
  createVehicleIdFilter,
  createWebhookIdOrNameFilter,
}) => {
  return (
    <StyledDrawer
      anchor="right"
      open
      onClose={closeDrawer}
    >
      {/* Need another form here because drawer gets created outside parent container */}
      <Form onSubmit={handleSubmit}>
        <Box display="flex" flexDirection="column" gap={4} height="100%">
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h2">{staticText.allFilters}</Typography>
            <IconButton
              onClick={closeDrawer}
              sx={{ border: '0' }}
            >
              <CloseRounded
                fontSize="small"
                sx={theme => ({ color: theme.palette.common.black })}
              />
            </IconButton>
          </Box>
          {createDateFilter({ id: 'date-range-picker-expanded', fullWidth: true })}
          {createSelectFilters([statusCodeFilter])}
          {createVehicleIdFilter({ id: 'vehicle-id-expanded', showErrorMessage: true })}
          {createWebhookIdOrNameFilter({ id: 'webhook-id-or-name-expanded' })}
          {createSelectFilters([eventTypeFilter])}
          <Box mt="auto" display="flex" justifyContent="flex-end" gap={1}>
            {resetButton}
            {submitButton}
          </Box>
        </Box>
      </Form>
    </StyledDrawer>
  );
};

export default AllFiltersDrawer;

AllFiltersDrawer.propTypes = {
  closeDrawer: func.isRequired,
  submitButton: element.isRequired,
  resetButton: element.isRequired,
  handleSubmit: func.isRequired,
  createDateFilter: func.isRequired,
  createSelectFilters: func.isRequired,
  createVehicleIdFilter: func.isRequired,
  createWebhookIdOrNameFilter: func.isRequired,
};
